import React from 'react';
import { Row, Column, Margin, IconText } from '@upgrade/react-components';
import formatDate from '@upgrade/ui-utils/formatters/date';
import { mdiChevronLeft } from '@mdi/js';

import Content from '../Content';
import Fluid from '../Fluid';

import { CREDIT_HEALTH_INSIGHTS_PATH } from '../../constants/path-constants';
import { Post } from './styles';
import RecentPosts from './recent';
import SearchForm from './search-form';
import RelatedArticles from '../common/RelatedArticles';
import { Heading, Text } from '../common/TypographyPublicSite';
import Link from '../common/Link';

const BlogPost = ({
  children,
  content,
  contentComponent,
  helmet,
  lastModified,
  recentBlogPosts = [],
  relatedArticles,
  title
}) => {
  const PostContent = contentComponent || Content;

  return (
    <Post>
      <Fluid>
        {helmet || ''}
        <Margin bottom="sm">
          <Link bold color="contentWeak" size="xs" to={CREDIT_HEALTH_INSIGHTS_PATH} type="text">
            <IconText
              color="contentWeak"
              icon={mdiChevronLeft}
              iconColor="contentWeak"
              iconSize="1.5rem"
              gap="xxs"
              textProps={{ size: 'xs' }}
            >
              Credit Health and Money Insights
            </IconText>
          </Link>
        </Margin>
        <Row gutter="xlarge">
          <Column xs={12} sm={recentBlogPosts.length === 0 ? 12 : 8}>
            <Heading as="h1" weight="500" size="sm" marginBottom="sm">
              {title}
            </Heading>
            {children}
            {lastModified ? (
              <Margin bottom="lg">
                <Text size="sm" color="contentWeak">
                  Last updated {formatDate(lastModified)}
                </Text>
              </Margin>
            ) : null}
            <PostContent content={content} />
          </Column>
          {recentBlogPosts.length > 0 && !relatedArticles?.length && (
            <Column xs={12} sm={4}>
              <SearchForm className="section" />
              <RecentPosts {...{ recentBlogPosts }} />
            </Column>
          )}
          {relatedArticles?.length > 0 && (
            <Column xs={12} sm={4}>
              <SearchForm className="section" />
              <RelatedArticles {...{ relatedArticles }} />
            </Column>
          )}
        </Row>
        {relatedArticles?.length > 0 && (
          <Row>
            <Column xs={12}>
              <RelatedArticles {...{ relatedArticles, bottom: true }} />
            </Column>
          </Row>
        )}
      </Fluid>
    </Post>
  );
};

export default BlogPost;
